export const LICENSE_ANCHOR_EXAMPLE = "0123456789ABCDEF0123456789ABCDEF0123456789ABCDEF0123456789ABCDEF";
const LICENSE_ANCHOR_PATTERN = /^[0-9A-F]{64}$/;
export function normalizeLicenseAnchors(value) {
    return [
        ...new Set(value.split(/\r?\n/).map((anchor)=>anchor.trim().toUpperCase()).filter(Boolean))
    ];
}
export function getLicenseAnchorsError(value) {
    const anchors = normalizeLicenseAnchors(value);
    if (anchors.length === 0) {
        return "At least one license anchor is required";
    }
    const invalidLine = value.split(/\r?\n/).findIndex((line)=>{
        const anchor = line.trim().toUpperCase();
        return anchor.length > 0 && !LICENSE_ANCHOR_PATTERN.test(anchor);
    });
    if (invalidLine !== -1) {
        return `Line ${invalidLine + 1} must be a 64-character hexadecimal anchor`;
    }
    return undefined;
}
